import React from 'react';

const SavedPaymentMethodsDropdown = ({ savedPaymentMethods, selectedPaymentMethod, onChange }) => {
  if (!savedPaymentMethods || savedPaymentMethods.length === 0) return null;
  
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Select a saved payment method
      </label>
      <select
        value={selectedPaymentMethod}
        onChange={onChange}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-brand-teal focus:border-brand-teal sm:text-sm rounded-md"
      >
        <option value="">Use a new card</option>
        {savedPaymentMethods.map(method => (
          <option key={method.id} value={method.id}>
            {method.card.brand.toUpperCase()} ending in {method.card.last4}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SavedPaymentMethodsDropdown; 